<template>
  <div class="MobileSearch">
    <!--    <div class="Mobile NavNotice&#45;&#45;info SearchSuggestions-header">Meet employers and win £100 at our free virtual event! Find out more-->
    <!--      <a-->
    <!--        class="Button Button&#45;&#45;orange"-->
    <!--        target="_blank"-->
    <!--        href="https://events.ratemyapprenticeship.co.uk/?utm_source=rma-email&utm_medium=email&utm_campaign=rma-ve-2021&utm_content=rmawebsite-all-banners">HERE!</a>-->
    <!--    </div>-->
    <search-type :is-mobile="true" />
    <div class="SearchInput">
      <search-auto-complete type="MobileSearch" />
    </div>
  </div>
</template>

<script>
import searchAutoComplete from './search-auto-complete.vue';
import searchType from './search-type.vue';

export default {
  components: {
    'search-auto-complete': searchAutoComplete,
    'search-type': searchType,
  },
  props: {},

  data() {
    return {};
  },
};

</script>

<style lang="scss">
  @import "../../../../scss/abstracts/abstracts";

  .MobileSearch {
    background: color($primary-color);
    padding: .5rem 1rem 1rem 1rem;
    @include respond-to(md) {
      display: none;
    }
    .autosuggest__results-container {
      top: 0px;
    }
  }
</style>
